import { z } from 'zod';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';

export const WriteBackToWorkdayViaWsJobApplicationCustomFieldPlaceToWrite =
  z.object({
    type: z.literal('jobApplicationCustomField'),

    /**
     * The custom namespace for writing the hiring readiness score.
     */
    customNs: z.string().optional(),

    /**
     * The custom field key for writing the hiring readiness score.
     */
    customFieldKey: z.string().optional(),

    /**
     * The custom object key for the outer XML element.
     * If not provided, customFieldKey will be used for both inner and outer elements.
     */
    customObjectKey: z.string().optional(),

    /**
     * The column in the CSV that contains the application ID for writing.
     */
    csvApplicationIdColumn: z.string().optional(),
  });

export type WriteBackToWorkdayViaWsJobApplicationCustomFieldPlaceToWrite =
  z.infer<typeof WriteBackToWorkdayViaWsJobApplicationCustomFieldPlaceToWrite>;

export const WriteBackToWorkdayViaWsPlaceToWrite =
  WriteBackToWorkdayViaWsJobApplicationCustomFieldPlaceToWrite;

export type WriteBackToWorkdayViaWsPlaceToWrite = z.infer<
  typeof WriteBackToWorkdayViaWsPlaceToWrite
>;

export const WriteBackToWorkdayViaWsStrategy = z.object({
  type: z.literal('workdayViaWs'),

  /**
   * The Workday SOAP version.
   */
  workdaySoapVersion: z.string().optional(),

  /**
   * The endpoint for the Workday SOAP service.
   */
  endpoint: z.string().optional(),

  /**
   * The username secret reference.
   */
  authUsernameSecretReference: SecretReference.optional(),

  /**
   * The password secret reference.
   */
  authPasswordSecretReference: SecretReference.optional(),

  /**
   * The places to write.
   */
  placesToWrite: z.array(WriteBackToWorkdayViaWsPlaceToWrite).optional(),
});

export type WriteBackToWorkdayViaWsStrategy = z.infer<
  typeof WriteBackToWorkdayViaWsStrategy
>;
